import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="payments--payment-options"
// Cascades payment_type options from payment_method, reveals a free-text input
// for "other", and writes the active value into the single hidden payment_type
// field so only ONE element submits transaction[payment_type] (avoids double-submit).
export default class extends Controller {
  static targets = ["methodSelect", "typeSelect", "typeRow", "customInput", "customRow", "paymentType"]
  static values = { map: Object }

  connect() {
    this.render()
  }

  render() {
    if (!this.hasMethodSelectTarget) return
    const method = this.methodSelectTarget.value
    const isCustom = method === "other"
    if (this.hasCustomRowTarget) this.customRowTarget.classList.toggle("d-none", !isCustom)
    if (this.hasTypeRowTarget) this.typeRowTarget.classList.toggle("d-none", isCustom)

    if (!isCustom && this.hasTypeSelectTarget) {
      const options = this.mapValue[method] || []
      const current = this.hasPaymentTypeTarget ? this.paymentTypeTarget.value : ""
      this.typeSelectTarget.innerHTML =
        `<option value=""></option>` +
        options
          .map(([label, code]) => `<option value="${code}"${code === current ? " selected" : ""}>${label}</option>`)
          .join("")
    }
    this.sync()
  }

  sync() {
    if (!this.hasMethodSelectTarget) return
    if (!this.hasPaymentTypeTarget) return
    if (this.methodSelectTarget.value === "other") {
      this.paymentTypeTarget.value = this.hasCustomInputTarget ? this.customInputTarget.value : ""
    } else {
      this.paymentTypeTarget.value = this.hasTypeSelectTarget ? this.typeSelectTarget.value : ""
    }
  }
}
